export default function Features() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES 256-bit encryption, the same standard used by governments and security experts worldwide.'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'No Activity Logs',
      description: 'We maintain a strict zero-logs policy. Your browsing history, connection times, and data content are never recorded or stored.'
    },
    {
      icon: 'ri-shut-down-line',
      title: 'Kill Switch Protection',
      description: 'Automatic kill switch instantly disconnects your internet if VPN connection drops, preventing any data leaks or exposure.'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously. Compatible with Windows, Mac, iOS, Android, and Linux operating systems.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Fast Speeds',
      description: 'Optimized servers ensure minimal speed loss. Stream, download, and browse without buffering or slowdowns.'
    },
    {
      icon: 'ri-time-line',
      title: '24/7 Connection Stability',
      description: 'Reliable infrastructure with 99.9% uptime guarantee. Stay connected and protected around the clock without interruptions.'
    }
  ];

  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Key Features</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the powerful features that make our VPN service the best choice for your online security.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-gray-50 rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${
                index % 3 === 1 ? 'lg:mt-8' : ''
              }`}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-full flex items-center justify-center mb-6 shadow-lg">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
